import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ResponsiveBar } from '@nivo/bar';
import { formatMoney } from 'accounting';

import { flatColors } from '../../../config/chartColors';

const ValuesChart = (props) => {
  const dataKeys = props.data.map(d => _.keys(d).find(k => k.includes('AvgMarketValue')));

  return (
    <div style={{ height: '24rem' }}>
      <ResponsiveBar
        data={props.data}
        indexBy="category"
        keys={dataKeys}
        enableLabel={false}
        colors={flatColors}
        padding={0.1}
        margin={{
          top: 10,
          right: 10,
          bottom: 100,
          left: 60,
        }}
        axisLeft={{
          format: v => formatMoney(v, '$', 0),
        }}
        axisBottom={{
          tickRotation: -45,
          tickSize: 0,
          legendOffset: 60,
        }}
        tooltip={props.tooltipTextFn}
        theme={{
          tooltip: {
            container: {
              background: '#efefef',
            },
          },
        }}
      />
    </div>
  );
};

ValuesChart.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.array.isRequired,
  tooltipTextFn: PropTypes.func,
};

ValuesChart.defaultProps = {
  tooltipTextFn: v => v.value,
};

export default ValuesChart;



// WEBPACK FOOTER //
// ./src/components/pages/financials/ValuesChart.jsx